import { render, staticRenderFns } from "./RentbackList.vue?vue&type=template&id=5fb5ffee&scoped=true&"
import script from "./RentbackList.vue?vue&type=script&lang=ts&"
export * from "./RentbackList.vue?vue&type=script&lang=ts&"
import style0 from "./RentbackList.vue?vue&type=style&index=0&id=5fb5ffee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5ffee",
  null
  
)

export default component.exports